import { Component, Input, OnInit } from '@angular/core';

export type ChipColour =
  | 'teal'
  | 'orange'
  | 'green-no-outline'
  | 'red-no-outline'
  | 'grey-no-outline';

@Component({
  selector: 'csi-chip',
  templateUrl: './chip.component.html',
  styleUrls: ['./chip.component.css']
})
export class ChipComponent implements OnInit {
  @Input() text: string = '';
  @Input() colour: ChipColour = 'teal';
  @Input() tooltip: string = '';
  @Input() applySideMargin: boolean = true;

  constructor() {}

  ngOnInit() {}
}
